// extracted by mini-css-extract-plugin
export default {"wrap":"Banner_wrap__8wuUU","body":"Banner_body__luBHB","head":"Banner_head__LvdsX","title":"Banner_title__+kfyM","subtitle":"Banner_subtitle__jWQ4e","text":"Banner_text__BNrU6"};